import { useState } from "react";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import AdditionalInfo from "../../components/InfoRow/AdditionalInfo";
import DiamondDetailsContent from "../../components/InfoRow/DiamondDetailsContent";
import ParameterDetails from "../../components/InfoRow/ParameterDetails";
// import Tabs from "../../components/tabs/Tabs";
import Accordion from "../../components/tabs/Accordion";
// import "./DiamondDetails.css";

export default function DiamondDetails({ data }) {
    const [logoError, setLogoError] = useState(false);
    const NO_IMAGE = `https://assets.diamondsoncall.com/assets/shapes/sample/noimage.jpg`;

    function numberWithCommas(x) {
        if (x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return "0.00";
        }
    }
    const CopyIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect x="9" y="9" width="11" height="11" rx="2" stroke="#2E384D" strokeWidth="2" />
            <path d="M5 15V6C5 4.89543 5.89543 4 7 4H16" stroke="#2E384D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const ExternalLinkIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M9 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V15" stroke="#2E384D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 14L19 5" stroke="#2E384D" strokeWidth="2" strokeLinecap="round" />
            <path d="M14 5H19V10" stroke="#2E384D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const safeImage = (img) => {
        if (!img || img === "null" || img === "-" || img.trim?.() === "") {
            return shapeFallback;
        }
        return img;
    };

    const shapeFallback = data?.shape
        ? `https://assets.diamondsoncall.com/assets/shapes/sample/${data.shape.toLowerCase()}-no.png`
        : NO_IMAGE;

    const galleryItems = [
        { type: "image", name:"mag", src: safeImage(data?.image) },
        ...(data?.heart ? [{ type: "image",  name:"heart", src: safeImage(data.heart) }] : []),
        ...(data?.arrow ? [{ type: "image", name:"arrow", src: safeImage(data.arrow) }] : []),
        ...(data?.asset ? [{ type: "image",  name:"asset", src: safeImage(data.asset) }] : []),
        ...(data?.video ? [{ type: "video", name:"video", src: data.video }] : []),
    ];

    const tabs = [
        {
            key: "diamond",
            title: "DIAMOND DETAILS",
            content: (
                <>
                    <DiamondDetailsContent data={data} />
                </>
            ),
        },
        {
            key: "param",
            title: "PARAMETERS DETAILS",
            content: <ParameterDetails data={data} />,
        },
        {
            key: "additional",
            title: "ADDITIONAL DETAILS",
            content: <AdditionalInfo data={data} />,
        },
    ];
    const handelCopy = ()=>{
        navigator.clipboard.writeText(data?.certificate)
        alert("Certificate number copied to clipboard")
    }

    return (
            <>
            <div className="logo-container">
                {data?.company_logo && !logoError ? (
                    <div className="logo-container-sub" style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={data?.company_logo} 
                            alt={data?.company_name}
                            height={50}
                            onError={() => setLogoError(true)}
                        />
                        <div className="cname-title" style={{ marginLeft: 15 }}>
                            {data?.company_name}
                        </div>
                    </div>
                ) : (
                    <div className="cname-title">{data?.company_name}</div>
                )}
            </div>
            <div className="container-fluid"> 
                <div className="page">
                    <div className="left">
                        <ImageGallery items={galleryItems} />
                    </div>
        
                    <div className="right">
                        <div className="diamond-detail-title" style={{marginBottom:15,marginTop:10}}>
                            {data?.shape} {data?.carat ? data?.carat.toFixed(2) : null} {data?.color}{" "}
                            {data?.clarity} {data?.cut} {data?.polish}{" "}
                            {data?.symmetry} {data?.fluorescence}
                        </div>
                        {data?.showsharecertificate && (
                            <div className="certi-link">
                                <a href={data?.certificate_link} >{data?.lab} : {data?.certificate} <span style={{marginLeft:5,marginTop:2}}><ExternalLinkIcon /></span></a>
                                <span style={{marginLeft:5,marginTop:2,cursor:"pointer"}} title="Copy certificate number" onClick={handelCopy}><CopyIcon /></span>
                            </div>
                        )}
    
                        {data?.showshareprice && (
                            <div className="price-title-sec">
                                <div className="perct-price">
                                    {data?.ourPriceShareExchangeSymbol}/CT{" "}
                                    {numberWithCommas(
                                        data?.ourRateShareExchange,
                                    )}
                                </div>
                                <div className="price-title">
                                    {data?.ourPriceShareExchangeSymbol}
                                    {numberWithCommas(
                                        data?.ourPriceShareExchange,
                                    )}
                                </div>
                            </div>
                        )}
                        <Accordion items={tabs} />
                        {/* <Tabs tabs={tabs} /> */}
                    </div>
                </div>
           </div>
            </>
    );
}
